import { defer, Observable, timer } from 'rxjs';
import { exhaustMap, first } from 'rxjs/operators';

// 請假、加班批次簽核共用：POST 建立任務拿到 task id，後端非同步處理，前端輪詢 GET 直到任務結束
export type BatchApprovalPayload = {
	application_ids: string[];
	is_approved: boolean;
};

export type BatchApprovalTask = {
	batch_approval_task_id: string;
};

// pending：尚未開始；running：逐筆處理中；completed：完成；failed：系統錯誤中斷
export type BatchApprovalTaskStatus = 'pending' | 'running' | 'completed' | 'failed';

export type BatchApprovalTaskResult = BatchApprovalTask & {
	status: BatchApprovalTaskStatus;
	is_approved: boolean;
	total_count: number;
	pending_count: number;
	// Toast「已同意／已不同意 N 筆申請」的 N，不含被略過的單
	success_count: number;
	// 已撤銷、已被代簽核或他人簽核而略過的筆數
	skipped_count: number;
	failed_count: number;
};

export const BATCH_APPROVAL_POLL_INTERVAL = 1000;

const isBatchApprovalTaskFinished = ({ status }: BatchApprovalTaskResult): boolean => (
	status === 'completed' || status === 'failed'
);

// exhaustMap：上一次 GET 還沒回來就略過這個 tick，避免同時打多支查詢
export const pollBatchApprovalTask = (
	getTaskResult: () => Promise<BatchApprovalTaskResult>,
	interval = BATCH_APPROVAL_POLL_INTERVAL,
): Observable<BatchApprovalTaskResult> => timer(interval, interval).pipe(
	exhaustMap(() => defer(getTaskResult)),
	first(isBatchApprovalTaskFinished),
);
